"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _reactAddonsPureRenderMixin = _interopRequireDefault(require("react-addons-pure-render-mixin"));

var _ComposerToolbarContainer = _interopRequireDefault(require("composer-lib/containers/composer/ComposerToolbarContainer"));

var _UIToolBar = _interopRequireDefault(require("UIComponents/nav/UIToolBar"));

var _UIToolBarGroup = _interopRequireDefault(require("UIComponents/nav/UIToolBarGroup"));

var _default = (0, _createReactClass.default)({
  displayName: "ComposerToolbarGroup",
  mixins: [_reactAddonsPureRenderMixin.default],
  propTypes: {
    className: _propTypes.default.string,
    left: _propTypes.default.node,
    right: _propTypes.default.node,
    addKeyCommandListener: _propTypes.default.func,
    handleKeyCommand: _propTypes.default.func,
    removeKeyCommandListener: _propTypes.default.func,
    properties: _propTypes.default.instanceOf(_immutable.Map),
    saveQuestion: _propTypes.default.func
  },
  render: function render() {
    var _this$props = this.props,
        className = _this$props.className,
        left = _this$props.left,
        right = _this$props.right,
        addKeyCommandListener = _this$props.addKeyCommandListener,
        handleKeyCommand = _this$props.handleKeyCommand,
        removeKeyCommandListener = _this$props.removeKeyCommandListener,
        properties = _this$props.properties,
        saveQuestion = _this$props.saveQuestion;
    var classes = (0, _classnames.default)((0, _defineProperty2.default)({}, className, !!className));
    return _react.default.createElement(_UIToolBar.default, {
      className: classes
    }, _react.default.createElement(_UIToolBarGroup.default, null, left), _react.default.createElement(_UIToolBarGroup.default, null, _react.default.createElement(_ComposerToolbarContainer.default, {
      addKeyCommandListener: addKeyCommandListener,
      handleKeyCommand: handleKeyCommand,
      removeKeyCommandListener: removeKeyCommandListener,
      properties: properties,
      saveQuestion: saveQuestion
    })), _react.default.createElement(_UIToolBarGroup.default, null, right));
  }
});

exports.default = _default;
module.exports = exports.default;